import {Injectable} from '@angular/core';
import {BuildUrlsService, ConfirmDialogData, DialogConfig, GeneralService, PromiseService} from 'ac-infra';
import {GroupsRestService} from '../apis/groups-rest.service';
import * as _ from 'lodash';
import {TenantsRestService} from '../apis/tenants-rest.service';
import {DevicesRestService} from '../apis/devices-rest.service';
import {DeviceSSOActionsService} from './device-SSO-actions.service';
import {RestResponseSuccess} from '../../../common/server-actions/rest';
import {Actions} from '../../../common/server-actions/actions';
import {LinksRestService} from '../apis/links-rest.service';
import {
    EntitySelectionDialogComponent,
    EntitySelectionDialogObject
} from '../../dialogs/entity-selection-dialog/entity-selection-dialog.component';
import {ChannelsRestService} from '../apis/channels-rest.service';
import {
    ExternalApplicationsActionsService
} from '../../../system/configuration/configuration-actions/external-applications-actions.service';
import {
    ExternalApplicationsRestService
} from '../../../system/configuration/configuration-api/external-applications-rest.service';
import {SessionService} from '../../../common/services/session.service';
import {AuthorizationService} from '../../../common/services/authorization.service';
import {NetworkGroupDialogComponent} from '../../dialogs/network-group-dialog/network-group-dialog.component';
import {NetworkServiceDialogComponent} from '../../dialogs/network-service-dialog/network-service-dialog.component';
import {NavigationService} from '../../../common/utilities/navigation.service';
import {ServerInfoService} from '../../../common/services/server-info.service';
import {LCCustomersRestService} from '../apis/lc-customers-rest.service';
import {ConstantStringsService} from '../../../common/utilities/constant-strings.service';
import {CellTemplatesService} from '../../../common/utilities/cell-templates.service';
import {MetadataService} from '../../../metadata/metadata.service';
import {CommonColumnTemplatesService} from '../../../common/utilities/common-column-templates.service';
import {AuthGroup} from '../../../common/utilities/session-helper.service';
import {NetworkDataService} from '../data/network-data.service';
import {FilterUtilsService} from "../filter-utils.service";
import {
    ServiceCommercialInfoDialogComponent
} from "../../dialogs/service-commercial-info-dialog/service-commercial-info-dialog.component";

@Injectable({providedIn: 'root'})
export class GroupsActions extends Actions {

    visibleFieldsForEndpointsGroupInfo = ['description', 'tenantId', 'ldapGroupName', 'elementsCount'];

    visibleFieldsForTopologyGroupInfo = ['description', 'tenantId', 'elementsCount'];

    visibleFieldsForServiceGroupInfo = ['serviceName', 'status', 'applicationsStatus.management.serviceDeployStatus', 'fullName',
        'lcCustomerId', 'serviceSource', 'licenseType', 'channelName', 'serviceUcaasTenantId', 'isEnabled',
        'disabledTime', 'serviceProviderDetails', 'serviceTeamsDetails', 'freeDIDs', 'deviceManagerParams.serviceDeviceUrl',
        'meteringTag',
        'deviceManagerParams.maxDevicesPersonal',
        "deviceManagerParams.devicesPercentagePersonal",
        'deviceManagerParams.devicesCount.personal',

        'deviceManagerParams.maxDevicesMeeting',
        "deviceManagerParams.devicesPercentageMeeting",
        'deviceManagerParams.devicesCount.meeting',

        'parameters', 'vocaParams.adminEmail',  'vocaParams.domainName', 'commercialInfo.channelPONumber',
        'commercialInfo.paymentTerms', 'commercialInfo.terms', 'commercialInfo.operator', 'commercialInfo.approvalTime',
        'commercialInfo.deploymentType', 'commercialInfo.pocExpiryDate', 'commercialInfo.dpaNumber', 'serviceDeviceId'];

    visibleFieldsForSmartTapService = [
        'smartTapParams.licenseType',
        'smartTapParams.storage',
        'smartTapParams.licenseCount',
    ];

    pmStatusMap = {
        Fail: 'status-error',
        Initializing: 'status-unmonitored',
        'Not Polling': 'status-unmonitored',
        Success: 'status-ok',
        'Not Supported': 'status-unmonitored'
    };

    deploymentTypeList = [
        {value: 'POC', text: 'POC'},
        {value: 'PRODUCTION', text: 'Production'}
    ];

    termsList = [
        {value: 'PAYG', text: 'PAYG'},
        {value: 'MONTHS_12', text: '12 Months'},
        {value: 'MONTHS_24', text: '24 Months'},
        {value: 'MONTHS_36', text: '36 Months'},
    ];

    paymentTerms = {
        options: [
            {value: "PER_MONTH", text: "Per Month"},
            {value: "PER_YEAR", text: "Per Year"},
            {value: "ONE_TIME", text: "One Time"}
        ]
    };

    deployStatusToColor = {
        DRAFT: {color: GeneralService.statusColors.grayStatus},
        UNKNOWN: {color: GeneralService.statusColors.grayStatus},
        WARNING: {color: GeneralService.statusColors.orangeStatus},
        SUBMITTED: {color: GeneralService.statusColors.orangeStatus},
        DEPLOYING: {color: GeneralService.statusColors.orangeStatus},
        IN_PROGRESS: {color: GeneralService.statusColors.orangeStatus},
        INPROGRESS_RESOURCE_ALLOCATION: {color: GeneralService.statusColors.orangeStatus},
        INPROGRESS_ACCOUNT_CREATION: {color: GeneralService.statusColors.orangeStatus},
        INPROGRESS_AWAIT_CONSENT: {color: GeneralService.statusColors.orangeStatus},
        WAIT_FOR_CUSTOMER: {color: GeneralService.statusColors.orangeStatus},
        WAIT_FOR_SERVICE: {color: GeneralService.statusColors.orangeStatus},
        WAIT_FOR_PROVIDER: {color: GeneralService.statusColors.orangeStatus},
        READY_FOR_DEPLOYMENT: {color: GeneralService.statusColors.orangeStatus},
        READY_FOR_REMOVE: {color: GeneralService.statusColors.orangeStatus},
        REMOVING: {color: GeneralService.statusColors.orangeStatus},
        DELETING: {color: GeneralService.statusColors.orangeStatus},
        REMOVED: {color: GeneralService.statusColors.orangeStatus},
        ERROR: {color: GeneralService.statusColors.redStatus},
        FAILED: {color: GeneralService.statusColors.redStatus},
        CREATE_FAILED: {color: GeneralService.statusColors.redStatus},
        DELETE_FAILED: {color: GeneralService.statusColors.redStatus},
        NOT_EXIST: {color: GeneralService.statusColors.redStatus},
        CONNECTION_ERROR: {color: GeneralService.statusColors.redStatus},
        DEPLOYED: {color: GeneralService.statusColors.greenStatus},
        READY: {color: GeneralService.statusColors.greenStatus},
        COMPLETED: {color: GeneralService.statusColors.greenStatus},
        CREATED: {color: GeneralService.statusColors.greenStatus},
        DELETED: {color: GeneralService.statusColors.greenStatus},
    };

    deployStatusMap = {
        DRAFT: 'status-unmonitored',
        UNKNOWN: 'status-unmonitored',
        WARNING: 'status-warning',
        SUBMITTED: 'status-warning',
        DEPLOYING: 'status-warning',
        IN_PROGRESS: 'status-warning',
        INPROGRESS_RESOURCE_ALLOCATION: 'status-warning',
        INPROGRESS_ACCOUNT_CREATION: 'status-warning',
        INPROGRESS_AWAIT_CONSENT: 'status-warning',
        WAIT_FOR_CUSTOMER: 'status-warning',
        WAIT_FOR_SERVICE: 'status-warning',
        WAIT_FOR_PROVIDER: 'status-warning',
        READY_FOR_DEPLOYMENT: 'status-warning',
        READY_FOR_REMOVE: 'status-warning',
        REMOVING: 'status-warning',
        DELETING: 'status-warning',
        REMOVED: 'status-warning',
        ERROR: 'status-error',
        FAILED: 'status-error',
        CREATE_FAILED: 'status-error',
        DELETE_FAILED: 'status-error',
        NOT_EXIST: 'status-error',
        CONNECTION_ERROR: 'status-error',
        DEPLOYED: 'status-ok',
        READY: 'status-ok',
        COMPLETED: 'status-ok',
        CREATED: 'status-ok',
        DELETED: 'status-ok',
    };
    isGlobalScope;

    constructor(private groupsRestService: GroupsRestService,
                private devicesRestService: DevicesRestService,
                private deviceSSOActionsService: DeviceSSOActionsService,
                private linksRestService: LinksRestService,
                private networkDataService: NetworkDataService,
                private channelsRestService: ChannelsRestService,
                private sessionService: SessionService,
                private navigationService: NavigationService,
                private filterUtilsService: FilterUtilsService,
                private buildUrlsService: BuildUrlsService,
                private externalApplicationsRestService: ExternalApplicationsRestService,
                private authorizationService: AuthorizationService,
                private cellTemplatesService: CellTemplatesService,
                private commonColumnTemplatesService: CommonColumnTemplatesService,
                private lcCustomersRestService: LCCustomersRestService,
                private tenantsRestService: TenantsRestService) {
        super({entityName: 'group', entityService: groupsRestService, isWsEntity: true});
    }

    networkGroupsFetchFn = (parameters, isService, type, callback, lcCustomerId?) => {
        let url;
        const wrappedParameters: any = {pager: parameters.paging, sort: parameters.sorting, detail: 1};
        if (isService) {
            url = 'topology/services';
        } else {
            wrappedParameters.filter = {type};
        }

        if (lcCustomerId) {
            wrappedParameters.filter = wrappedParameters.filter || {};
            wrappedParameters.filter.lcCustomerId = lcCustomerId;
        }

        this.networkDataService.getGroupsForGrid(wrappedParameters, type, callback, url);
    };

    getServicesColumns = () => {
        this.isGlobalScope = AuthorizationService.isGlobalScope;
        const serviceSourceMapper = MetadataService.getType('ServiceSource');
        const licenseTypesList = MetadataService.getType('ServiceLicenseType');
        const isAuthorizedAccordingToMode = this.authorizationService.validationAccordingToMode({
            ovoc: 'all',
            oneLive: AuthGroup.system_users
        });

        return [
            {field: 'fullName', title: 'Full Name', widthByHeader: true, headerSort: false},
            {field: 'serviceName', title: 'Name', minWidth: 140, headerSort: true},
            {
                field: 'serviceSource', title: 'Service Type', widthByHeader: true, headerSort: true,
                formatter: this.cellTemplatesService.iconAndTextTemplateWithMapper({
                    mapper: serviceSourceMapper,
                    componentInputs: {textClass: 'service-source-'}
                })
            },
            {
                field: 'parentId',
                title: 'Owner',
                headerSort: false,
                minWidth: 120,
                formatter: this.ownerFormatter
            },
            this.commonColumnTemplatesService.getStatusColumn({widthByHeader: true, headerSort: true}),
            this.commonColumnTemplatesService.getStatusColumn({
                field: 'applicationsStatus.management.serviceDeployStatus',
                title: 'Deploy status',
                widthByHeader: true,
                statusMap: this.deployStatusToColor
            }),
            {
                field: 'licenseType',
                title: 'License Type',
                widthByHeader: true,
                headerSort: false,
                formatter: this.cellTemplatesService.complexDictionaryTemplateFn(licenseTypesList, 'viewName')
            },
            {
                field: 'isEnabled',
                title: 'Enabled',
                widthByHeader: true,
                headerSort: false,
                formatter: this.cellTemplatesService.booleanTemplateFn()
            },
            this.commonColumnTemplatesService.getTenantColumn({isActive: isAuthorizedAccordingToMode}),
            {
                field: 'attachedLinks',
                title: ConstantStringsService.linkOrProviderSideMany,
                widthByHeader: true,
                headerSort: false,
                isActive: !this.isGlobalScope,
                formatter: this.cellTemplatesService.nameTemplateFromService({restService: this.linksRestService})
            },
            {
                field: 'attachedDevices',
                title: ConstantStringsService.deviceOrTeamsSide,
                widthByHeader: true,
                headerSort: false,
                isActive: !this.isGlobalScope,
                formatter: this.cellTemplatesService.nameTemplateFromService({restService: this.devicesRestService})
            },
            {
                field: 'serviceDeviceId',
                title: 'Service Entity',
                widthByHeader: true,
                headerSort: false,
                formatter: this.serviceEntityFormatter
            }
        ];
    };

    serviceEntityFormatter = (cell) => {
        const value = cell.getValue();
        if(value){
            const externalApps = this.externalApplicationsRestService.getAllEntities();
            const externalApp = externalApps.find((app) => app.nodeId === value);

            if(externalApp){
                return externalApp.name + ' (Regional)';
            }else{
                const device = this.devicesRestService.getEntityById(value);
                return device?.name;
            }
        }

        return '';
    };

    ownerFormatter = (cell) => {
        const entity = cell.getRow();
        const parentType = entity.parentType;
        const parentId = entity.parentId;

        if(parentType && parentId){
            const entityType = parentType.toLowerCase() === 'customer' ? 'lcCustomers' : parentType.toLowerCase() + 's';
            const parent = this.wsEntitiesService.getEntityByEntityType(entityType, parentId);

            return parent?.name + '(' + parentType + ')' || '';
        }

        return '';
    };

    editGroup = (group) => {
        const success = (response: RestResponseSuccess) => this.openGroupDetailsDialog(response.data);
        const failure = () => {
        };
        this.groupsRestService.getById({success, failure, id: group.id});
    };

    openGroupDetailsDialog = (group, type?) => {
        const tenants = this.tenantsRestService.getAllEntities();
        if (tenants === undefined || (tenants && tenants.length === 0)) {
            this.acDialogService.info('Can not add groups when there are no tenants.');
            return;
        }

        const isEdit = !_.isEqual(group, {});
        const id = group.id;

        const emptyGroup: any = {name: '', type};
        if (type === 'TOPOLOGY') {
            emptyGroup.attachedDevices = [];
            emptyGroup.attachedLinks = [];
            emptyGroup.attachedSites = [];
        }

        const endpointsGroupToSend = isEdit ? _.cloneDeep(group) : emptyGroup;

        if (isEdit) {
            this.cleanEmptyValues(endpointsGroupToSend);
        }

        const dialogData = {entity: endpointsGroupToSend, isEdit};
        const serverCallback = (onSuccess, onFailure) => {
            if (isEdit) {
                this.groupsRestService.edit(onSuccess, onFailure, dialogData.entity, id);
            } else {
                this.groupsRestService.add(onSuccess, onFailure, dialogData.entity);
            }
        };
        this.genericAction({
            dialogComponentType: NetworkGroupDialogComponent,
            serverCallback,
            dialogData,
        });
    };

    editService = (lcCustomer, pageName = undefined, service = undefined) => {
        this.getUMPDeviceAndOpenSSOConnection({
            actionName: 'ovoc_ovl_edit',
            selectedTenantId: lcCustomer.tenantId,
            pageName,
            lcCustomerId: lcCustomer.id,
            service
        });
    };

    editServiceSettings = ({service, type}) => {
        const serviceURL = 'topology/services';
        const success = (response: RestResponseSuccess) => {
            this.openServiceDetailsDialog({service: response.data, type});
        };
        this.groupsRestService.getById({
            url: serviceURL,
            success,
            extendParameters: true,
            skipPopulateFilter: true,
            id: service.id
        });
    };

    openServiceDetailsDialog = ({service = undefined, type, lcCustomer = undefined, tenant = undefined}) => {
        const isEdit = !!service;
        const serviceURL = isEdit ? 'topology/services' : 'topology/actions/createService';
        const id = service?.id;
        let tenants;
        let lcCustomers;
        if(type === 'LIVEOPS_360_MANAGEMENT'){
            tenants = this.getTenantsThatTheirServiceIsEnabled({serviceType: type});
        }else{
            lcCustomers = this.getLCCustomersThatTheirServiceIsEnabled({serviceType: type});
        }
        const dialogData: any = {
            entity: (service || {
                serviceName: '',
                operatorName: this.sessionService.activeSession.name,
                serviceSource: type
            }), lcCustomers, tenants, type, isEdit
        };

        if(!service && type === 'HYBRID_ENTITIES'){
            dialogData.entity.hybridParams = {licenseType: 'ACM'};
        }

        if (isEdit && type === 'HYBRID_ENTITIES') {
            dialogData.entity.hybridParams = {licenseType: service.licenseType};
        }

        if (lcCustomer) {
            dialogData.lcCustomer = lcCustomer;

            if (lcCustomer.preconfigId) {
                dialogData.entity.preconfigId = lcCustomer.preconfigId;
            }
        }

        if (tenant) {
            dialogData.tenant = tenant;

            if (tenant.preconfigId) {
                dialogData.entity.preconfigId = tenant.preconfigId;
            }
        }

        const serverCallback = (onSuccess, onFailure) => {
            if (ServerInfoService.oneLiveMode && !ServerInfoService?.serverInfo?.meteringEnabled) {
                delete dialogData.entity?.meteringTag;
            }

            if (isEdit) {
                this.groupsRestService.edit(onSuccess, onFailure, dialogData.entity, id, serviceURL);
            } else {
                this.groupsRestService.add(onSuccess, onFailure, dialogData.entity, serviceURL);
            }
        };
        const dialogComponentType = NetworkServiceDialogComponent;

        this.genericAction({serverCallback, dialogData, dialogComponentType});
    };

    deleteProviderSide = (service) => {
        const siteLocations = this.linksRestService.getAllEntities(service.attachedLinks);
        const dialogData: EntitySelectionDialogObject = {
            entity: {id: -1, name: ''},
            items: siteLocations,
            selectLabel: ConstantStringsService.linkOrProviderSide,
            dialogType: 'link'
        };

        if (!siteLocations || siteLocations.length === 0) {
            this.acDialogService.info('Selected service doesn\'t have any ' + ConstantStringsService.linkOrProviderSideMany);
        } else {
            this.acDialogService.open(EntitySelectionDialogComponent, {
                onSubmit: () => {
                    const selectedSiteLocation = dialogData.entity?.id > 0 && this.linksRestService.getEntityById(dialogData.entity.id);
                    if (selectedSiteLocation?.serviceInfo?.umpSiteLocationId) {
                        this.groupsRestService.deleteById({
                            id: dialogData.entity.id,
                            url: 'topology/services/' + service.id + '/serviceSiteLocations'
                        });
                    }
                },
                dialogData,
                id: 'select-service-location-dialog',
                title: 'Delete ' + ConstantStringsService.linkOrProviderSide + (service ? ' (Service: ' + service.name + ')' : ''),
                submitButtonText: 'Delete'
            });
        }
    };

    openServiceCommercialInfoDialog = ({
                                           tenant = undefined,
                                           lcCustomer = undefined,
                                           action = undefined,
                                           commitmentFileId = undefined,
                                           isLogin = false,
                                           callback = undefined,
                                           closeCallback = undefined,
                                           session = undefined
                                       }) => {
        const commercialInfo = {
            terms: 'MONTHS_36',
            paymentTerms: 'PER_MONTH',
            channelPONumber: '',
            deploymentType: 'PRODUCTION'
        };
        const additionalSettings: any = {
            commitmentFileId: tenant?.commitmentFileId || commitmentFileId,
            approval: false,
            fileWasUploaded: false,
            isLogin
        };
        if (tenant) {
            additionalSettings.tenantId = tenant.id;
        }
        const dialogData: any = {additionalSettings};
        if (!isLogin) {
            dialogData.commercialInfo = commercialInfo;
        }
        const dialogRef = this.acDialogService.open();
        const serverCallback = () => {
            this.acDialogService.closeDialog(dialogRef);

            if (isLogin) {
                callback(session);
            } else {
                const onSuccess = (response) => {
                    if (lcCustomer) {
                        lcCustomer.preconfigId = response?.data?.commercialInfoId;
                    } else if (tenant) {
                        tenant.preconfigId = response?.data?.commercialInfoId;
                    }


                    action?.onClick(lcCustomer || tenant);
                }

                const onFailure = () => {
                    this.acDialogService.error('Service commercial information failed');
                }
                this.groupsRestService.add(onSuccess, onFailure, dialogData.commercialInfo, 'topology/actions/serviceCommercialInfo');
            }
        }

        const dialogConfig: DialogConfig = {
            id: 'service-commercial-info-dialog',
            title: 'Commercial Information',
            cancelButtonText: isLogin ? 'Logout' : 'Close',
            submitButtonText: isLogin ? 'Login' : 'Add Service',
            onCancel: () => isLogin ? closeCallback() : undefined,
            width: 600,
            height: isLogin ? 450 : 650
        };

        this.genericAction({
            serverCallback,
            dialogData,
            dialogComponentType: ServiceCommercialInfoDialogComponent,
            dialogConfig,
            dialogRef
        });
    };

    deleteTeamsSide = (service) => {
        const teams = service.attachedDevices && service.attachedDevices.length > 0 ? this.devicesRestService.getEntityById(service.attachedDevices[0]) : undefined;

        if (!teams) {
            this.acDialogService.info('Selected service doesn\'t have any teams attached');
        } else if (teams) {
            this.groupsRestService.remove(() => {
            }, () => {
            }, 'topology/services/' + service.id + '/serviceTeamsDevice');
        }
    };

    openSelectCustomersDialog = (service, type) => {
        const customers = this.lcCustomersRestService.getAllEntities().filter((customer) => customer.tenantId === service.tenantId && customer?.services?.[type]);

        const dialogData: EntitySelectionDialogObject = {
            entity: {id: service.lcCustomerId || -1, name: ''},
            items: customers,
            selectLabel: 'Customers',
            dialogType: 'lcCustomer'
        };
        this.acDialogService.open(EntitySelectionDialogComponent, {
            onSubmit: ({entity}) => {
                entity?.id && this.updateServiceCustomer(service, entity.id);
            },
            dialogData,
            id: 'select-customers-dialog',
            title: 'Change Customer' + (service ? ' (Service: ' + service.name + ')' : ''),
            submitButtonText: 'Move'
        });
    };

    updateServiceCustomer = (service, lcCustomerId) => {
        this.groupsRestService.edit(() => {
        }, () => {
        }, {lcCustomerId}, service.id, 'topology/services');
    };

    getLCCustomer = (serviceType, oneLCCustomerIsChosenFromTheLCCustomersTable, lcCustomers, service, dialogTitle, callback) => {
        if (lcCustomers.length === 0) {
            this.acDialogService.info(oneLCCustomerIsChosenFromTheLCCustomersTable ? 'The selected Customer is not compatible for this action' : 'No compatible customers found.');
            return;
        }

        if (service || (lcCustomers.length === 1 && serviceType !== 'VOCA')) {
            const lcCustomerId = service && service.lcCustomerId || lcCustomers[0].id;
            const lcCustomer = lcCustomerId && this.lcCustomersRestService.getEntityById(lcCustomerId);
            lcCustomer && callback(lcCustomer);
        } else {
            this.openCustomerDialog(serviceType, lcCustomers, dialogTitle, callback);
        }
    };

    openCustomerDialog = (serviceType, lcCustomers, dialogTitle, callback) => {
        const filteredLCCustomer = this.filterUtilsService.getSelectedLiveEntity('lcCustomer');
        const foundCustomer = filteredLCCustomer && lcCustomers.find((lcCustomer) => lcCustomer.id === filteredLCCustomer.id);
        const dialogData: EntitySelectionDialogObject = {entity: {id: foundCustomer?.id || undefined, name: ''}, items: lcCustomers, selectLabel: 'Select Customer', dialogType: 'lcCustomer'};

        if(serviceType === 'VOCA') {
            dialogData.serviceType = serviceType;
            dialogData.subRegion = {value: -2};
        }
        this.acDialogService.open(EntitySelectionDialogComponent, {
            onSubmit: () => {
                if (dialogData.entity.id) {
                    const lcCustomer = this.lcCustomersRestService.getEntityById(dialogData.entity.id);

                    if(serviceType === 'VOCA') {
                        lcCustomer.subRegion = dialogData.subRegion.value;
                    }
                    lcCustomer && callback(lcCustomer);
                }
            },
            dialogData,
            id: 'select-lc-customer-dialog',
            title: dialogTitle,
            submitButtonText: 'Select'
        });
    };

    getUMPDeviceAndOpenSSOConnection = ({
                                            actionName,
                                            selectedTenantId,
                                            pageName = undefined,
                                            lcCustomerId = undefined,
                                            service = undefined,
                                            preconfigId = undefined
                                        }) => {
        const filter = {familyType: ['UMP'], tenantId: [selectedTenantId]};
        this.getDeviceWithFilter(filter).then((UMPDevice: any) => {
            if (UMPDevice) {
                this.deviceSSOActionsService.startEntityServlet(UMPDevice, (value) => {
                    let partialUrl = UMPDevice.ssoUrl + (actionName || '') + '/';
                    const params: any = {page: pageName, customerId: service?.serviceId};
                    if (lcCustomerId) {
                        params.lcCustomerId = lcCustomerId;
                    }

                    if (preconfigId) {
                        params.preconfigId = preconfigId;
                    }

                    partialUrl = partialUrl + this.buildUrlsService.addQueryParams(params);

                    const url = this.deviceSSOActionsService.buildSSOUrl(partialUrl);
                    this.deviceSSOActionsService.openEntityInNewTab(url);
                });
            } else {
                this.acDialogService.info('No UMP Device found for this tenant');
            }
        });
    };

    getDeviceWithFilter = (filter) => {
        const deferred = PromiseService.defer();

        const onSuccess = (response: RestResponseSuccess) => {
            deferred.resolve(response.data.devices[0]);
        };

        this.devicesRestService.getEntitiesWithFilter(onSuccess, () => {
            deferred.resolve();
        }, {filter});

        return deferred.promise;
    };


    serviceAction({lcCustomer = undefined, service = undefined, page = 'create', type, skipGetToken = false}: {
        lcCustomer?: any;
        skipGetToken?: boolean;
        service?: any;
        page: 'create' | 'overview' | 'edit' | 'delete' | 'management' | 'customer';
        type: 'MEETING_INSIGHTS' | 'STNG' | 'STNG_REGIONAL' | 'MI_REGIONAL';
    }) {
        if (['MI_REGIONAL', 'STNG_REGIONAL'].includes(type)) {
            const uri = (type === 'MI_REGIONAL' ? 'meetingInsights' : 'interactionRecording');
            this.externalApplicationsRestService.getExternalEntityConfiguration(uri, (response) => {
                const externalApp = response.data.applicationStatus;
                this.openServiceAction(externalApp, lcCustomer, service, page, type, 'nodeId', skipGetToken);
            }, () => {
            });
        } else {
            const filter = {productType: [type], tenantId: [lcCustomer.tenantId]};
            this.getDeviceWithFilter(filter).then((device: any) => {
                this.openServiceAction(device, lcCustomer, service, page, type, 'id', skipGetToken);
            });
        }
    }

    openServiceAction = (entity, lcCustomer, service, page, type, propertyName, skipGetToken,) => {
        if (!lcCustomer?.iamAccountId) {
            this.acDialogService.fail("Selected customer doesn't have IAM Account ID");
            return;
        }

        if (entity) {

            if (skipGetToken) {
                this.openPageWithParameters({lcCustomer, service, entity, page});
            } else {
                const onSuccess = (response: RestResponseSuccess) => {
                    this.openPageWithParameters({response, lcCustomer, service, entity, page});
                };

                this.externalApplicationsRestService.getIAMToken(onSuccess, () => null, type, entity?.[propertyName]);
            }
        } else {
            const message = (propertyName === 'id') ? 'No Device found for this tenant' : 'External Application was not found for this action'
            this.acDialogService.info(message);
        }
    }

    openPageWithParameters({response = undefined, lcCustomer = undefined, service = undefined, entity, page = undefined}) {
        const sso_code = response?.data.code;
        const access_token = response?.data.accessToken;
        const code = this.sessionService.activeSession.sessionId;

        const parameters: any = {};

        if(lcCustomer){
            parameters.lcCustomerId = lcCustomer.id;
            if (lcCustomer?.preconfigId && page === 'create') {
                parameters.preconfigId = lcCustomer?.preconfigId;
            }
        }


        if (access_token) {
            parameters.access_token = access_token;
            parameters.code = code;
        }

        if (sso_code) {
            parameters.sso_code = sso_code;
        }

        if (lcCustomer?.msTenantId) {
            parameters.customerMsTenantId = lcCustomer.msTenantId;
        }

        if (lcCustomer?.iamAccountId) {
            parameters.customerIAMAccountId = lcCustomer.iamAccountId;
        }

        if (lcCustomer?.channelId) {
            const channel = this.channelsRestService.getEntityById(lcCustomer.channelId);
            if (channel?.iamAccountId) {
                parameters.channelIAMAccountId = channel.iamAccountId;
            }
        }

        if (lcCustomer?.tenantId) {
            const tenant = this.tenantsRestService.getEntityById(lcCustomer.tenantId);
            if (tenant?.iamAccountId) {
                parameters.spIAMAccountId = tenant.iamAccountId;
            }
        }

        let url = entity?.ssoUrl || entity?.externalServiceToolUrl;

        if (page && page !== 'customer') {
            url = url + 'tenant-management';
        }

        if (['overview', 'edit', 'delete'].includes(page)) {
            url = url + '/' + service.serviceId + '/' + page;
        } else if (page === 'create') {
            url = url + '/' + page;
        }

        this.navigationService.openNewWindow(url, parameters);
    }

    openVocaPage = ({
                        tenant = undefined,
                        channel = undefined,
                        lcCustomer = undefined,
                        service = undefined,
                        uri = 'Services',
                        page = undefined
                    }: {
        tenant?: any;
        channel?: any;
        lcCustomer?: any;
        service?: any;
        page?: 'management';
        uri: 'ServiceProviders' | 'Providers' | 'Services';
    }) => {
        const deviceId = service?.serviceDeviceId || (tenant || channel || lcCustomer)?.subRegion;
        if(deviceId){
            const vocaDevice = this.devicesRestService.getEntityById(deviceId);
            if(vocaDevice){
                this.openVocaPageWithParameters(vocaDevice, uri, page, tenant, channel, lcCustomer, service);
            }
        }
    };

    openVocaPageWithParameters = (vocaApp, uri, page, tenant, channel, lcCustomer, service) => {
        const code = this.sessionService.activeSession.sessionId;
        let url = vocaApp.ssoUrl + '/' + uri;

        const parameters: any = {code};

        if (page) {
            parameters.page = page;
        }

        if (tenant) {
            parameters.tenantId = tenant.id;
        }

        if (channel) {
            parameters.tenantId = channel.tenantId;
            parameters.channelId = channel.id;
        }

        if (lcCustomer) {
            parameters.tenantId = lcCustomer.tenantId;
            parameters.channelId = lcCustomer.channelId;
            parameters.lcCustomerId = lcCustomer.id;

            if (lcCustomer.preconfigId) {
                parameters.preconfigId = lcCustomer.preconfigId;
            }
        }

        if (service) {
            parameters.serviceId = service.id;
        }

        this.navigationService.openNewWindow(url, parameters);
    }

    openGeneralDeviceManagerPage(service = undefined) {
        const tenants = this.tenantsRestService.getAllEntities();
        const services = this.groupsRestService.getAllEntities(undefined, false, 'services');

        const tenantId = (tenants?.length === 1 ? tenants[0].id : undefined);
        const serviceId = service?.serviceId || (services?.length === 1 ? services[0].serviceId : undefined);

        this.openDeviceManagerPage('general', tenantId, serviceId);
    }

    openDeviceManagerPage = (page, tenantId = undefined, serviceId = undefined, channelMsTenantId = undefined, lcCustomer = undefined) => {
        const params: any = {
            page,
            code: this.sessionService.activeSession.sessionId,
            tenantId,
            customerId: serviceId,
            channelMsTenantId
        };

        if (lcCustomer) {
            params.lcCustomerId = lcCustomer.id;

            if (lcCustomer.preconfigId && page === 'create_customer') {
                params.preconfigId = lcCustomer.preconfigId;
            }
        }

        const deviceManagerURL = ExternalApplicationsActionsService.getDeviceManagerURL() + this.buildUrlsService.addQueryParams(params);

        console.log('SSO URL-', deviceManagerURL);// don't remove - for QA and UI use
        window.open(deviceManagerURL);
    };

    openZoomPage = ({tenant = undefined, lcCustomer = undefined, pageName = 'leads', serviceType = 'ZOOM'}) => {
        let channelId;

        this.externalApplicationsRestService.getExternalEntityConfiguration('zoom', (response) => {
                const zoomApp = response.data.applicationStatus;
                const sessionId = this.sessionService.activeSession.sessionId;
                let url = zoomApp.ssoUrl;

                const params: any = {
                    page: pageName,
                    code: sessionId,
                    serviceType,
                    tenantId: (lcCustomer?.tenantId || tenant?.id),
                    lcCustomerId: lcCustomer?.id && pageName !== 'numbers' ? lcCustomer.id : undefined
                };

                if (tenant?.preconfigId || lcCustomer?.preconfigId) {
                    params.preconfigId = tenant?.preconfigId || lcCustomer?.preconfigId;
                }

                if (this.authorizationService.validForChannel()) {
                    const channels = this.channelsRestService.getAllEntities();
                    channelId = channels.length === 1 ? channels[0]?.id : undefined;
                    params.channelId = channelId;
                }

                url = url + this.buildUrlsService.addQueryParams(params);
                this.deviceSSOActionsService.openEntityInNewTab(url);
            },
            () => {
            });
    };

    disableService = (service) => {
        const confirmMessage = 'Endpoints will no longer be able to be assigned to a disabled service, Are you sure?';

        const onSuccessCallback = (response) => {
            if (response.status === 202) {
                this.acDialogService.info(response.data.description);
            }
        };

        const serverCallback = (onSuccess, onFailure) => {
            this.groupsRestService.serviceRestAction(onSuccess, onFailure, [service], 'disableService');
        };
        const dialogData: ConfirmDialogData = {entitiesArray: [service], confirmMessage, onSuccessCallback};
        this.genericConfirmAction({serverCallback, dialogData, dialogConfig: {submitButtonText: 'disable'}});
    };

    getLCCustomersThatTheirServiceIsEnabled = ({lcCustomers = [], service = undefined, serviceType}) => {
        if (service) {
            lcCustomers = [this.lcCustomersRestService.getEntityById(service.lcCustomerId)];
        } else {
            lcCustomers = (lcCustomers?.length > 0 ? lcCustomers : this.lcCustomersRestService.getAllEntities()).filter((lcCustomer) => {
                return lcCustomer?.services?.[serviceType];
            });
        }

        return lcCustomers;
    };

    getTenantsThatTheirServiceIsEnabled = ({tenants = [], service = undefined, serviceType}) => {
        if (service) {
            tenants = [this.tenantsRestService.getEntityById(service.tenantId)];
        } else {
            tenants = (tenants?.length > 0 ? tenants : this.tenantsRestService.getAllEntities()).filter((tenant) => {
                return tenant?.services?.[serviceType].enabled;
            });
        }

        return tenants;
    };
}
